import { useClientPagination } from "../../hooks/useClientPagination";
import {
  LISTING_PAGE_SIZE,
  filterVillage,
} from "../../services/paginationConfig";
import {
  type VillageSortKey,
  useVillageSorting,
} from "./hooks/useVillageSorting";
import type { VillagesPageProps } from "./types";
import { humanizeStatus } from "./utils";
import { ListingPaginationControls } from "../../components/common/ListingPaginationControls";

export function VillagesPage({ villages, onSelectVillage }: VillagesPageProps) {
  const { sortKey, setSortKey, sortedVillages } = useVillageSorting(villages);
  const {
    query,
    setQuery,
    page,
    setPage,
    totalPages,
    totalFiltered,
    pageItems,
  } = useClientPagination(sortedVillages, LISTING_PAGE_SIZE, filterVillage);

  return (
    <section className="listing-page">
      <div className="listing-page__inner">
        <h1 className="listing-page__heading fade-in">Villages</h1>

        <div className="listing-controls fade-in fade-in--delay-1">
          <input
            type="text"
            className="listing-search"
            placeholder="Search villages..."
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              setPage(1);
            }}
          />
          <select
            className="listing-sort"
            value={sortKey}
            onChange={(e) => {
              setSortKey(e.target.value as VillageSortKey);
              setPage(1);
            }}
            aria-label="Sort villages"
          >
            <option value="survivors-desc">Survivor count (high to low)</option>
            <option value="az">A-Z</option>
            <option value="za">Z-A</option>
          </select>
          <span className="listing-count">{totalFiltered} villages</span>
          <div className="listing-controls__right">
            <ListingPaginationControls
              page={page}
              totalPages={totalPages}
              onPageChange={setPage}
              className="listing-pagination--inline"
            />
          </div>
        </div>

        <div className="listing-grid fade-in fade-in--delay-2">
          {pageItems.map((village) => (
            <button
              key={village.id}
              type="button"
              className="listing-card"
              onClick={() => onSelectVillage(village.id)}
            >
              <div className="listing-card__thumb">
                <img src="/village-icon.png" alt="" loading="lazy" />
              </div>
              <div className="listing-card__body">
                <p className="listing-card__name">{village.title}</p>
                <p className="listing-card__meta">
                  <span className="listing-card__label">Township:</span>{" "}
                  {village.township || "Unknown"}
                </p>
                <p className="listing-card__status">
                  <span className="listing-card__label">Status:</span>{" "}
                  <span className="listing-card__value listing-card__value--green">
                    {humanizeStatus(village.reference?.status2019)}
                  </span>
                </p>
                <p className="listing-card__stat">
                  <span className="listing-card__label">
                    Survivors interviewed:
                  </span>{" "}
                  <span className="listing-card__value listing-card__value--green">
                    {village.stats.interviewCount}
                  </span>
                </p>
              </div>
            </button>
          ))}
          {pageItems.length === 0 && (
            <p className="listing-empty">No villages match your search.</p>
          )}
        </div>
      </div>
    </section>
  );
}
